export const ProductCategory = [
  'Papinhas',
  'Fórmulas infantis',
  'Compostos lácteos',
  'Mucilon'
];
